import * as THREE from 'three'
import { coneVertices } from './constants'
import type { Group } from 'three'

interface SpotLightCone {
    group: Group
}

class SpotLightCone {
    constructor() {
        this.initialize()
    }

    /**
     * Sets up SpotLight cone meshes and materials needed to create 3D cone and adds said items to an internal roup
     */
    initialize() {
        this.group = new THREE.Group()
        const coneGeometry = new THREE.BufferGeometry().setFromPoints(coneVertices)
        coneGeometry.computeVertexNormals()

        const reducer = 3.0
        const cWidth = 4 / reducer
        const cHeight = 3 / reducer
        const cLength = 4 / reducer
        const coneTransformation = new THREE.Matrix4().makeScale(cWidth, cHeight, cLength)
        const coneFillMaterial = new THREE.MeshStandardMaterial({
            color: 0xffff00,
            opacity: 0.5,
            transparent: true,
            flatShading: true,
        })

        coneGeometry.applyMatrix4(coneTransformation)

        const coneFill = new THREE.Mesh(coneGeometry, coneFillMaterial)
        const edgeGeometry = new THREE.EdgesGeometry(coneGeometry, 1)
        const coneMaterial = new THREE.LineBasicMaterial({ color: 0xffff00, linewidth: 2 })
        const cone = new THREE.LineSegments(edgeGeometry, coneMaterial)
        const points = [new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 0, 0)]
        const lineGeometry = new THREE.BufferGeometry().setFromPoints(points)
        const lineMaterial = new THREE.LineBasicMaterial({ color: 0xf39d22, linewidth: 2 })
        const line = new THREE.Line(lineGeometry, lineMaterial)

        cone.position.set(0, 0, 0)
        cone.rotation.set(0, 0, 0)
        cone.name = "SpotlightPrismCone"

        coneFill.position.set(0, 0, 0)
        coneFill.rotation.set(0, 0, 0)
        coneFill.name = "SpotlightPrismFill"

        line.name = "SpotlightPrismLines"

        this.group.add(cone)
        this.group.add(coneFill)
        this.group.add(line)
    }
}

export { SpotLightCone }